import { ColorName } from '@panaya/ui/styles-to-code';
import { IconSize } from './types';

export const DefaultIconColor: ColorName = 'currentColor';
export const DefaultIconSize: IconSize = 'md';
